import React from 'react'
import {Checkbox, FormControlLabel} from '@material-ui/core'

const Check = ({label, defaultValue, fieldId, readonly, handleChange}) => {
	const onChange = (e) => {
		const value = e.target.checked ? '1' : '0'
		handleChange('c' + fieldId, value)
	}

	return (
		<div style={{marginBottom: '30px'}}>
			<FormControlLabel
				control={
					<Checkbox
						disableRipple
						checked={defaultValue === '1' ? true : false}
						color="primary"
						onChange={onChange}
						disabled={readonly}
						// indeterminate={!defaultValue}
					/>
				}
				label={<span dangerouslySetInnerHTML={{__html: label}} />}
			/>
		</div>
	)
}

export default React.memo(Check)